import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { GenericService } from '../generic.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { environment } from '../../environments/environment';
import { Dc, Diplome, Certif, Skill, Langue, Experience, Realisation, General, Adresse, Collaborateur} from '../entities/dossier'
import {Dcc} from '../entities/dcc';
import {Tag} from '../entities/tag';
import { User } from './../entities/user'
import { TagsInputModule } from 'ngx-tags-input/dist';
import { NotificationService } from '../notification.service';



@Component({
  selector: 'app-dcc',
  templateUrl: './dcc.component.html',
  styleUrls: ['./dcc.component.css']
})
export class DccComponent implements OnInit {

  public showSpinner : boolean = false;
  public general : General;
  public adresse : Adresse;
  public dcc: Dcc;
  public experience : Experience;
  public experiences : Experience[] = [];
  public realisation : Realisation;
  public realisations : Realisation[] = [];
  public skills : Skill[] = [];
  public skill : Skill;
  //public justSaved : String;
  public dc : Dc;
  public diplomes : Diplome[] = [];
  public diplome : Diplome;
  //public successMessage : String;
  //public errorMessage : String;
  //public MsgError : String;
  public certifs : Certif[] = [];
  public langues : Langue[] = [];
  public tempTags: String[] = [];
  public dskillsTags : Array<Array<any>> = [];
  public newTag : String;
  public tag : {
    value : String,
    display : String;
  }
  public titre : String;
  public resume : String;

  public currentExpChecked : boolean = false;
  public isValid = false;
  public collaborateur : Collaborateur;
  public user : User;

  public  PAYS :Array<any> = [
    {label:'France',display:'France'},
    {label:'Afghanistan',display:'Afghanistan'},
    {label:'Afrique_Centrale',display:'Afrique Centrale'},
    {label:'Afrique_du_sud',display:'Afrique du sud'},
    {label:'Albanie',display:'Albanie'},
    {label:'Algerie',display:'Algerie'},
    {label:'Allemagne',display:'Allemagne'},
    {label:'Andorre',display:'Andorre'},
    {label:'Angola',display:'Angola'},
    {label:'Anguilla',display:'Anguilla'},
    {label:'Arabie_Saoudite',display:'Arabie Saoudite'},
    {label:'Argentine',display:'Argentine'},
    {label:'Armenie',display:'Armenie'},
    {label:'Australie',display:'Australie'},
    {label:'Autriche',display:'Autriche'},
    {label:'Azerbaidjan',display:'Azerbaidjan'},

    {label:'Bahamas',display:'Bahamas'},
    {label:'Bangladesh',display:'Bangladesh'},
    {label:'Barbade',display:'Barbade'},
    {label:'Bahrein',display:'Bahrein'},
    {label:'Belgique',display:'Belgique'},
    {label:'Belize',display:'Belize'},
    {label:'Benin',display:'Benin'},
    {label:'Bermudes',display:'Bermudes'},
    {label:'Bielorussie',display:'Bielorussie'},
    {label:'Bolivie',display:'Bolivie'},
    {label:'Botswana',display:'Botswana'},
    {label:'Bhoutan',display:'Bhoutan'},
    {label:'Boznie_Herzegovine',display:'Boznie Herzegovine'},
    {label:'Bresil',display:'Bresil'},
    {label:'Brunei',display:'Brunei'},
    {label:'Bulgarie',display:'Bulgarie'},
    {label:'Burkina_Faso',display:'Burkina Faso'},
    {label:'Burundi',display:'Burundi'},

    {label:'Caiman',display:'Caiman'},
    {label:'Cambodge',display:'Cambodge'},
    {label:'Cameroun',display:'Cameroun'},
    {label:'Canada',display:'Canada'},
    {label:'Canaries',display:'Canaries'},
    {label:'Cap_vert',display:'Cap vert'},
    {label:'Chili',display:'Chili'},
    {label:'Chine',display:'Chine'},
    {label:'Chypre',display:'Chypre'},
    {label:'Colombie',display:'Colombie'},

    {label:'Comores',display:'Comores'},
    {label:'Congo',display:'Congo'},
    {label:'Congo_democratique',display:'Congo democratique'},
    {label:'Cook',display:'Cook'},
    {label:'Coree_du_Nord',display:'Coree du Nord'},
    {label:'Coree_du_Sud',display:'Coree du Sud'},
    {label:'Costa_Rica',display:'Costa Rica'},
    {label:'Cote_d_Ivoire',display:'Coted\'Ivoire'},
    {label:'Croatie',display:'Croatie'},
    {label:'Cuba',display:'Cuba'},

    {label:'Danemark',display:'Danemark'},
    {label:'Djibouti',display:'Djibouti'},
    {label:'Dominique',display:'Dominique'},

    {label:'Egypte',display:'Egypte'},
    {label:'Emirats_Arabes_Unis',display:'Emirats Arabes Unis'},
    {label:'Equateur',display:'Equateur'},
    {label:'Erythree',display:'Erythree'},
    {label:'Espagne',display:'Espagne'},
    {label:'Estonie',display:'Estonie'},
    {label:'Etats_Unis',display:'Etats Unis'},
    {label:'Ethiopie',display:'Ethiopie'},
    {label:'Dominique',display:'Dominique'},

    {label:'Falkland',display:'Falkland'},
    {label:'Feroe',display:'Feroe'},
    {label:'Fidji',display:'Fidji'},
    {label:'Finlande',display:'Finlande'},

    {label:'Gabon',display:'Gabon'},
    {label:'Gambie',display:'Gambie'},
    {label:'Georgie',display:'Georgie'},
    {label:'Ghana',display:'Ghana'},
    {label:'Gibraltar',display:'Gibraltar'},
    {label:'Grece',display:'Grece'},
    {label:'Grenade',display:'Grenade'},
    {label:'Groenland',display:'Groenland'},
    {label:'Guadeloupe',display:'Guadeloupe'},
    {label:'Guam',display:'Guam'},
    {label:'Guatemala',display:'Guatemala'},
    {label:'Guernesey',display:'Guernesey'},
    {label:'Guinee',display:'Guinee'},
    {label:'Guinee_Bissau',display:'Guinee Bissau'},
    {label:'Guinee_equatoriale',display:'Guinee equatoriale'},
    {label:'Guyana',display:'Guyana'},
    {label:'Guyane_Francaise',display:'Guyane Francaise'},

    {label:'Haiti',display:'Haiti'},
    {label:'Hawaii',display:'Hawaii'},
    {label:'Honduras',display:'Honduras'},
    {label:'Hong_Kong',display:'Hong Kong'},
    {label:'Hongrie',display:'Hongrie'},

    {label:'Inde',display:'Inde'},
    {label:'Indonesie',display:'Indonesie'},
    {label:'Iran',display:'Iran'},
    {label:'Iraq',display:'Iraq'},
    {label:'Irlande',display:'Irlande'},
    {label:'Islande',display:'Islande'},
    {label:'Israel',display:'Israel'},
    {label:'Italie',display:'Italie'},

    {label:'Jamaique',display:'Jamaique'},
    {label:'Jan_Mayen',display:'Jan Mayen'},
    {label:'Japon',display:'Japon'},
    {label:'Jersey',display:'Jersey'},
    {label:'Jordanie',display:'Jordanie'},

    {label:'Kazakhstan',display:'Kazakhstan'},
    {label:'Kenya',display:'Kenya'},
    {label:'Kirghizstan',display:'Kirghizstan'},
    {label:'Kiribati',display:'Kiribati'},
    {label:'Koweit',display:'Koweit'},

    {label:'Laos',display:'Laos'},
    {label:'Lesotho',display:'Lesotho'},
    {label:'Lettonie',display:'Lettonie'},
    {label:'Liban',display:'Liban'},
    {label:'Liberia',display:'Liberia'},
    {label:'Liechtenstein',display:'Liechtenstein'},
    {label:'Lituanie',display:'Lituanie'},
    {label:'Luxembourg',display:'Luxembourg'},
    {label:'Lybie',display:'Lybie'},

    {label:'Macao',display:'Macao'},
    {label:'Macedoine',display:'Macedoine'},
    {label:'Madagascar',display:'Madagascar'},
    {label:'Madère',display:'Madère'},
    {label:'Malaisie',display:'Malaisie'},
    {label:'Malawi',display:'Malawi'},
    {label:'Maldives',display:'Maldives'},
    {label:'Mali',display:'Mali'},
    {label:'Malte',display:'Malte'},
    {label:'Man',display:'Man'},
    {label:'Mariannes_du_Nord',display:'Mariannes du Nord'},
    {label:'Maroc',display:'Maroc'},
    {label:'Marshall',display:'Marshall'},
    {label:'Martinique',display:'Martinique'},
    {label:'Maurice',display:'Maurice'},
    {label:'Mauritanie',display:'Mauritanie'},
    {label:'Mayotte',display:'Mayotte'},
    {label:'Mexique',display:'Mexique'},
    {label:'Micronesie',display:'Micronesie'},
    {label:'Midway',display:'Midway'},
    {label:'Moldavie',display:'Moldavie'},
    {label:'Monaco',display:'Monaco'},
    {label:'Mongolie',display:'Mongolie'},
    {label:'Montserrat',display:'Montserrat'},
    {label:'Mozambique',display:'Mozambique'},

    {label:'Namibie',display:'Namibie'},
    {label:'Nauru',display:'Nauru'},
    {label:'Nepal',display:'Nepal'},
    {label:'Nicaragua',display:'Nicaragua'},
    {label:'Niger',display:'Niger'},
    {label:'Nigeria',display:'Nigeria'},
    {label:'Niue',display:'Niue'},
    {label:'Norfolk',display:'Norfolk'},
    {label:'Norvege',display:'Norvege'},
    {label:'Nouvelle_Caledonie',display:'Nouvelle Caledonie'},
    {label:'Nouvelle_Zelande',display:'Nouvelle Zelande'},

    {label:'Oman',display:'Oman'},
    {label:'Ouganda',display:'Ouganda'},
    {label:'Ouzbekistan',display:'Ouzbekistan'},

    {label:'Pakistan',display:'Pakistan'},
    {label:'Palau',display:'Palau'},
    {label:'Palestine',display:'Palestine'},
    {label:'Panama',display:'Panama'},
    {label:'Papouasie_Nouvelle_Guinee',display:'Papouasie Nouvelle Guinee'},
    {label:'Paraguay',display:'Paraguay'},
    {label:'Pays_Bas',display:'Pays Bas'},
    {label:'Perou',display:'Perou'},
    {label:'Philippines',display:'Philippines'},
    {label:'Pologne',display:'Pologne'},
    {label:'Polynesie',display:'Polynesie'},
    {label:'Porto_Rico',display:'Porto Rico'},
    {label:'Portugal',display:'Portugal'},

    {label:'Qatar',display:'Qatar'},

    {label:'Republique_Dominicaine',display:'Republique Dominicaine'},
    {label:'Republique_Tcheque',display:'Republique Tcheque'},
    {label:'Reunion',display:'Reunion'},
    {label:'Roumanie',display:'Roumanie'},
    {label:'Royaume_Uni',display:'Royaume Uni'},
    {label:'Russie',display:'Russie'},
    {label:'Rwanda',display:'Rwanda'},

    {label:'Sahara_Occidental',display:'Sahara Occidental'},
    {label:'Sainte_Lucie',display:'Sainte Lucie'},
    {label:'Saint_Marin',display:'Saint Marin'},
    {label:'Salomon',display:'Salomon'},
    {label:'Salvador',display:'Salvador'},
    {label:'Samoa_Occidentales',display:'Samoa Occidentales'},
    {label:'Samoa_Americaine',display:'Samoa Americaine'},
    {label:'Nouvelle_Zelande',display:'Nouvelle Zelande'},
    {label:'Senegal',display:'Senegal'},
    {label:'Seychelles',display:'Seychelles'},
    {label:'Sierra_Leone',display:'Sierra Leone'},
    {label:'Singapour',display:'Singapour'},
    {label:'Slovaquie',display:'Slovaquie'},
    {label:'Slovenie',display:'Slovenie'},
    {label:'Somalie',display:'Somalie'},
    {label:'Soudan',display:'Soudan'},
    {label:'Sri_Lanka',display:'Sri Lanka'},
    {label:'Suede',display:'Suede'},
    {label:'Suisse',display:'Suisse'},
    {label:'Surinam',display:'Surinam'},
    {label:'Swaziland',display:'Swaziland'},
    {label:'Syrie',display:'Syrie'},

    {label:'Tadjikistan',display:'Tadjikistan'},
    {label:'Taiwan',display:'Taiwan'},
    {label:'Tonga',display:'Tonga'},
    {label:'Tanzanie',display:'Tanzanie'},
    {label:'Tchad',display:'Tchad'},
    {label:'Thailande',display:'Thailande'},
    {label:'Tibet',display:'Tibet'},
    {label:'Timor_Oriental',display:'Timor Oriental'},
    {label:'Togo',display:'Togo'},
    {label:'Trinite_et_Tobago',display:'Trinite et Tobago'},
    {label:'Tristan_da_cunha',display:'Tristan da cunha'},
    {label:'Tunisie',display:'Tunisie'},
    {label:'Turkmenistan',display:'Turkmenistan'},
    {label:'Turquie',display:'Turquie'},

    {label:'Ukraine',display:'Ukraine'},
    {label:'Uruguay',display:'Uruguay'},

    {label:'Vanuatu',display:'Vanuatu'},
    {label:'Vatican',display:'Vatican'},
    {label:'Venezuela',display:'Venezuela'},
    {label:'Vierges_Americaines',display:'Vierges Americaines'},
    {label:'Vierges_Britanniques',display:'Vierges Britanniques'},
    {label:'Vietnam',display:'Vietnam'},

    {label:'Wake',display:'Wake'},
    {label:'Wallis_et_Futuma',display:'Wallis et Futuma'},

    {label:'Yemen',display:'Yemen'},
    {label:'Yougoslavie',display:'Yougoslavie'},

    {label:'Zambie',display:'Zambie'},
    {label:'Zimbabwe',display:'Zimbabwe'},
    ];

    public  NATIONNALITE :Array<any> = [
      {label:'FRA',display:'Française (France)'},
      {label:'AFG',display:'Afghane (Afghanistan)'},
      {label:'ALB',display:'Albanaise (Albanie)'},
      {label:'DZA',display:'Algérienne (Algérie)'},
      {label:'DEU',display:'Allemande (Allemagne)'},
      {label:'USA',display:'Americaine (États-Unis)'},
      {label:'AND',display:'Andorrane (Andorre)'},
      {label:'AGO',display:'Angolaise (Andorre)'},
      {label:'ATG',display:'Antiguaise et Barbudienne (Antigua et Barbuda)'},
      {label:'ARG',display:'Argentine (Argentine)'},
      {label:'ARM',display:'Armenienne (Arménie)'},
      {label:'AUS',display:'Australienne (Australie)'},
      {label:'AUT',display:'Autrichienne (Autriche)'},
      {label:'AZE',display:'Azerbaïdjanaise (Azerbaïdjan)'},

      {label:'BHS',display:'Bahamienne (Bahamas)'},
      {label:'BHR',display:'Bahreinienne (Bahreïn)'},
      {label:'BGD',display:'Bangladaise (Bangladesh)'},
      {label:'BRB',display:'Barbadienne (Barbade)'},
      {label:'BEL',display:'Belge (Belgique)'},
      {label:'BLZ',display:'Belizienne (Belize)'},
      {label:'BEN',display:'Béninoise (Bénin)'},
      {label:'BTN',display:'Bhoutanaise (Bhoutan)'},
      {label:'BLR',display:'Biélorusse (Biélorussie)'},
      {label:'MMR',display:'Birmane (Birmanie)'},
      {label:'GNB',display:'Bissau Guinéenne (Guinée Bissau)'},
      {label:'BOL',display:'Bolivienne (Bolivie)'},
      {label:'BIH',display:'Bosnienne (Bosnie Herzégovine)'},
      {label:'BWA',display:'Botswanaise (Botswana)'},
      {label:'BRA',display:'Brésilienne (Brésil)'},
      {label:'GBR',display:'Britannique (Royaume Uni)'},
      {label:'BRN',display:'Brunéienne (Brunéi)'},
      {label:'BGR',display:'Bulgare (Bulgarie)'},
      {label:'BFA',display:'Burkinabée (Burkina)'},
      {label:'BDI',display:'Burundaise (Burundi)'},

      {label:'KHM',display:'Cambodgienne (Cambodge)'},
      {label:'CMR',display:'Camerounaise (Cameroun)'},
      {label:'CAN',display:'Canadienne (Canada)'},
      {label:'CPV',display:'Cap verdienne (Cap Vert)'},
      {label:'CAF',display:'Centrafricaine (Centrafrique)'},
      {label:'CHL',display:'Chilienne (Chili)'},
      {label:'CHN',display:'Chinoise (Chine)'},
      {label:'CYP',display:'Chypriote (Chypre)'},
      {label:'COL',display:'Colombienne (Colombie)'},
      {label:'COM',display:'Comorienne (Comores)'},
      {label:'COG',display:'Congolaise (Congo Brazzaville)'},
      {label:'COD',display:'Congolaise (Congo Kinshasa)'},
      {label:'COK',display:'Cookienne (Îles Cook)'},
      {label:'CRI',display:'Costaricaine (Costa Rica)'},
      {label:'HRV',display:'Croate (Croatie)'},
      {label:'CUB',display:'Cubaine (Cuba)'},

      {label:'DNK',display:'Danoise (Danemark)'},
      {label:'DJI',display:'Djiboutienne (Djibouti)'},
      {label:'DOM',display:'Dominicaine (République dominicaine)'},
      {label:'DMA',display:'Dominiquaise (Dominique)'},

      {label:'EGY',display:'Égyptienne (Égypte)'},
      {label:'ARE',display:'Émirienne (Émirats arabes unis)'},
      {label:'GNQ',display:'Équato guineenne (Guinée équatoriale)'},
      {label:'ECU',display:'Équatorienne (Équateur)'},
      {label:'ERI',display:'Érythréenne (Érythrée)'},
      {label:'ESP',display:'Espagnole (Espagne)'},
      {label:'TLS',display:'Est timoraise (Timor Leste)'},
      {label:'EST',display:'Estonienne (Estonie)'},
      {label:'ETH',display:'Éthiopienne (Éthiopie)'},

      {label:'FJI',display:'Fidjienne (Fidji)'},
      {label:'FIN',display:'Finlandaise (Finlande)'},

      {label:'GAB',display:'Gabonaise (Gabon)'},
      {label:'GMB',display:'Gambienne (Gambie)'},
      {label:'GEO',display:'Georgienne (Géorgie)'},
      {label:'GHA',display:'Ghanéenne (Ghana)'},
      {label:'GRD',display:'Grenadienne (Grenade)'},
      {label:'GTM',display:'Guatémaltèque (Guatemala)'},
      {label:'GIN',display:'Guinéenne (Guinée)'},
      {label:'GUY',display:'Guyanienne (Guyana)'},

      {label:'IND',display:'Indienne (Inde)'},
      {label:'IDN',display:'Indonésienne (Indonésie)'},
      {label:'IRQ',display:'Irakienne (Iraq)'},
      {label:'IRN',display:'Iranienne (Iran)'},
      {label:'IRL',display:'Irlandaise (Irlande)'},
      {label:'ISL',display:'Islandaise (Islande)'},
      {label:'ISR',display:'Israélienne (Israël)'},
      {label:'ITA',display:'Italienne (Italie)'},
      {label:'CIV',display:'Ivoirienne (Côte d\'Ivoire)'},

      {label:'JAM',display:'Jamaïcaine (Jamaïque)'},
      {label:'JPN',display:'Japonaise (Japon)'},
      {label:'JOR',display:'Jordanienne (Jordanie)'},

      {label:'KAZ',display:'Kazakhstanaise (Kazakhstan)'},
      {label:'KEN',display:'Kenyane (Kenya)'},
      {label:'KGZ',display:'Kirghize (Kirghizistan)'},
      {label:'KIR',display:'Kiribatienne (Kiribati)'},
      {label:'KNA',display:'Kittitienne et Névicienne (Saint Christophe et Niévès)'},
      {label:'KWT',display:'Koweïtienne (Koweït)'},

      {label:'LAO',display:'Laotienne (Laos)'},
      {label:'LSO',display:'Lesothane (Lesotho)'},
      {label:'LVA',display:'Lettone (Lettonie)'},
      {label:'LBN',display:'Libanaise (Liban)'},
      {label:'LBR',display:'Libérienne (Libéria)'},
      {label:'LBY',display:'Libyenne (Libye)'},
      {label:'LIE',display:'Liechtensteinoise (Liechtenstein)'},
      {label:'LTU',display:'Lituanienne (Lituanie)'},
      {label:'LUX',display:'Luxembourgeoise (Luxembourg)'},

      {label:'MKD',display:'Macédonienne (Macédoine)'},
      {label:'MYS',display:'Malaisienne (Malaisie)'},
      {label:'MWI',display:'Malawienne (Malawi)'},
      {label:'MDV',display:'Maldivienne (Maldives)'},
      {label:'MDG',display:'Malgache (Madagascar)'},
      {label:'MLI',display:'Maliennes (Mali)'},
      {label:'MLT',display:'Maltaise (Malte)'},
      {label:'MAR',display:'Marocaine (Maroc)'},
      {label:'MHL',display:'Marshallaise (Îles Marshall)'},
      {label:'MUS',display:'Mauricienne (Maurice)'},
      {label:'MRT',display:'Mauritanienne (Mauritanie)'},
      {label:'MEX',display:'Mexicaine (Mexique)'},
      {label:'FSM',display:'Micronésienne (Micronésie)'},
      {label:'MDA',display:'Moldave (Moldovie)'},
      {label:'MCO',display:'Monegasque (Monaco)'},
      {label:'MNG',display:'Mongole (Mongolie)'},
      {label:'MNE',display:'Monténégrine (Monténégro)'},
      {label:'MOZ',display:'Mozambicaine (Mozambique)'},

      {label:'NAM',display:'Namibienne (Namibie)'},
      {label:'NRU',display:'Nauruane (Nauru)'},
      {label:'NLD',display:'Néerlandaise (Pays-Bas)'},
      {label:'NZL',display:'Néo Zélandaise (Nouvelle Zélande)'},
      {label:'NPL',display:'Népalaise (Népal)'},
      {label:'NIC',display:'Nicaraguayenne (Nicaragua)'},
      {label:'NGA',display:'Nigériane (Nigéria)'},
      {label:'NER',display:'Nigérienne (Niger)'},
      {label:'NIU',display:'Niuéenne (Niue)'},
      {label:'PRK',display:'Nord coréenne (Corée du Nord)'},
      {label:'NOR',display:'Norvégienne (Norvège)'},

      {label:'OMN',display:'Omanaise (Oman)'},
      {label:'UGA',display:'Ougandaise (Ouganda)'},
      {label:'UZB',display:'Ouzbéke (Ouzbékistan)'},

      {label:'PAK',display:'Pakistanaise (Pakistan)'},
      {label:'PLW',display:'Palaosienne (Palaos)'},
      {label:'PSE',display:'Palestinienne (Palestine)'},
      {label:'PAN',display:'Panaméenne (Panama)'},
      {label:'PNG',display:'Papouane Néo Guinéenne (Papouasie Nouvelle Guinée)'},
      {label:'PRY',display:'Paraguayenne (Paraguay)'},
      {label:'PER',display:'Péruvienne (Pérou)'},
      {label:'PHL',display:'Philippine (Philippines)'},
      {label:'POL',display:'Polonaise (Pologne)'},
      {label:'PRT',display:'Portugaise (Portugal)'},

      {label:'QAT',display:'Qatarienne (Qatar)'},

      {label:'ROU',display:'Roumaine (Roumanie)'},
      {label:'RUS',display:'Russe (Russie)'},
      {label:'RWA',display:'Rwandaise (Rwanda)'},

      {label:'LCA',display:'Saint Lucienne (Sainte Lucie)'},
      {label:'SMR',display:'Saint Marinaise (Saint Marin)'},
      {label:'VCT',display:'Saint Vincentaise et Grenadine (Saint Vincent et les Grenadines)'},
      {label:'SLB',display:'Salomonaise (Îles Salomon)'},
      {label:'SLV',display:'Salvadorienne (Salvador)'},
      {label:'WSM',display:'Samoane (Samoa)'},
      {label:'STP',display:'Santoméenne (Sao Tomé et Principe)'},
      {label:'SAU',display:'Saoudienne (Arabie saoudite)'},
      {label:'SEN',display:'Sénégalaise (Sénégal)'},
      {label:'SRB',display:'Serbe (Serbie)'},
      {label:'SYC',display:'Seychelloise (Seychelles)'},
      {label:'SLE',display:'Sierra Léonaise (Sierra Leone)'},
      {label:'SGP',display:'Singapourienne (Singapour))'},
      {label:'SVK',display:'Slovaque (Slovaquie)'},
      {label:'SVN',display:'Slovène (Slovénie)'},
      {label:'SOM',display:'Somalienne (Somalie)'},
      {label:'SDN',display:'Soudanaise (Soudan)'},
      {label:'LKA',display:'Sri Lankaise (Sri Lanka)'},
      {label:'ZAF',display:'Sud Africaine (Afrique du Sud)'},
      {label:'KOR',display:'Sud Coréenne (Corée du Sud)'},
      {label:'SSD',display:'Sud Soudanaise (Soudan du Sud)'},
      {label:'SWE',display:'Suédoise (Suède)'},
      {label:'CHE',display:'Suisse (Suisse)'},
      {label:'SUR',display:'Surinamaise (Suriname)'},
      {label:'SWZ',display:'Swazie (Swaziland)'},
      {label:'SYR',display:'Syrienne (Syrie)'},

      {label:'TJK',display:'Tadjike (Tadjikistan)'},
      {label:'TZA',display:'Tanzanienne (Tanzanie)'},
      {label:'TCD',display:'Tchadienne (Tchad)'},
      {label:'CZE',display:'Tchèque (Tchéquie)'},
      {label:'THA',display:'Thaïlandaise (Thaïlande)'},
      {label:'TGO',display:'Togolaise (Togo)'},
      {label:'TON',display:'Tonguienne (Tonga)'},
      {label:'TTO',display:'Trinidadienne (Trinité et Tobago)'},
      {label:'TUN',display:'Tunisienne (Tunisie)'},
      {label:'TKM',display:'Turkmène (Turkménistan)'},
      {label:'TUR',display:'Turque (Turquie)'},
      {label:'TUV',display:'Tuvaluane (Tuvalu)'},

      {label:'UKR',display:'Ukrainienne (Ukraine)'},
      {label:'URY',display:'Uruguayenne (Uruguay)'},

      {label:'VUT',display:'Vanuatuane (Vanuatu)'},
      {label:'VAT',display:'Vaticane (Vatican)'},
      {label:'VEN',display:'Vénézuélienne (Venezuela)'},
      {label:'VNM',display:'Vietnamienne (Viêt Nam)'},

      {label:'YEM',display:'Yéménite (Yémen)'},

      {label:'ZMB',display:'Zambienne (Zambie)'},
      {label:'ZWE',display:'Zimbabwéenne (Zimbabwe)'},
      ];

  public permisChecked : boolean = false;
  public ListLangue: string[] = ["Anglais","Français","Arabe",  "Allemand",  "Italien", "Chinois"];

  constructor(public _authService: AuthService,  private _genericService: GenericService,
    private _notifyService: NotificationService) { }

  ngOnInit() {

    // load draf dcc if exists
    this.loadDossierIfExists();

    // setting up field for writing
    this.dcc = new Dcc();
    this.dc = new Dc();
    this.diplome = new Diplome();
    this.diplomes.push(this.diplome);
    this.experience = new Experience();
    this.experiences.push(this.experience);
    this.realisation = new Realisation();
    this.realisations.push(this.realisation);
    this.general = new General();
    this.adresse = new Adresse();
    this.collaborateur = new Collaborateur();
    this.user = new User();
    // push a new domaine skills
    this.skill = new Skill();
    this.skills.push(this.skill);
    // certificat
    let certif = new Certif();
    this.certifs.push(certif);
    // langues
    let langue = new Langue();
    this.langues.push(langue);

  }

  // ajouter une novelle experience
  addExperience(){
    let newExperience = new Experience();
    this.experiences.push(newExperience);
  }
  // supprimer une experience
  deleteExperience(index){
    this.experiences.splice(index,1);
  }

  // ajouter une novelle experience
  addRealisation(){
    let newRealisation = new Realisation();
    this.realisations.push(newRealisation);
  }
  //Supprimer une langue
  deleteLangue(index){
    this.langues.splice(index,1);
}

   // ajouter un nouveau diplome
   addDiplome(){
    let newDiplome = new Diplome();
    this.diplomes.push(newDiplome);
  }
  // supprimer un diplome
  deleteDiplome(index){
    this.diplomes.splice(index,1);
  }

  // ajouoter un nouveau domaine de compétences
  addDomaine(){
    let newSkill = new Skill();
    this.skills.push(newSkill);
  }

  // supprimer un domaine de compétences
  deleteDomaine(index){
    this.skills.splice(index,1);
  }

  // ajouter une nouvelle certification
  addCertif(){
    let newCertif = new Certif();
    this.certifs.push(newCertif);
  }

  // supprimer un certification
  deleteCertif(index){
    this.certifs.splice(index,1);
  }

  // ajouter une langue
  addLangue(){
    let newLangue = new Langue();
    this.langues.push(newLangue);
  }

  permisChanged(actual){
    this.permisChecked = actual;
  }
  // save draft version of dc
  save(isValid){
    //this.clearMessages();
    if(isValid){
      this.dcc.status = "draft";
      this.dcc.user = this._authService.getAuthenticatedUsername();
      this.dc.experience = this.experiences;
      this.dcc.diplomes = this.diplomes;
      // skills
      for(let i=0;i<this.skills.length;i++){
       this.skills[i].dskills = this.mapTagsToString(this.dskillsTags[i]);
      }
      this.dc.skills = this.skills;
      // certifs
      this.dc.certifs = this.certifs;
      // langues
      this.dcc.langues = this.langues;
      this.dc.resume = this.resume;
      this.dc.titre = this.titre;
      this.dcc.dc = this.dc;
      // save draft versions
      this.showSpinner = true;
      this._genericService.saveResource(environment.dccUrl, this.dcc, true ,environment.contentTypes.json)
      .subscribe(
        data => this.postSaveDraftVersion(data),
        error => {
          this.showSpinner = false;
          //this.errorMessage = <any>error;
        }
      );
      }else{
        /*window.scrollTo(0, 0);
        this.errorMessage = "Formulaire invalide ";
        this.MsgError = this.errorMessage;
        this.resetErrorMessage();*/
        this._notifyService.showError("Formulaire invalide", "Save", 3000)


      }
  }

  // Post traitement : enregistrement de la version brouillon
  postSaveDraftVersion(dcc){
    this.showSpinner = false;
    this.loadDossierIfExists();
    //window.scrollTo(0, 0);
    //this.successMessage = "Vos modification ont été enregistérés ! Pensez à valider votre dossier";
    //this.justSaved = this.successMessage;
    //this.resetSuccesMessage();
    this._notifyService.showSuccess("Vos modification ont été enregistérés ! Pensez à valider votre dossier", "Save", 3000)

  }


  // load the draft version of dc
  loadDossierIfExists(){
    //this.clearMessages();
    this.showSpinner = true;
    this._genericService.getResource(environment.loadDccUrl, true ,0)
    .subscribe(
      data => this.fillDraftDcc(data),
      error => {
        this.showSpinner = false;
        //this.errorMessage = <any>error
      }
    );
  }

  // validate dc : save it in
  validate(isValid){
    //this.clearMessages();
    if(confirm("Etes vous sure de valider ")) {
      this.showSpinner = true;
      this._genericService.getResource(environment.validateDcc, true ,0)
      .subscribe(
      data => this.postValidate(data),
      error => {
        this.showSpinner = false;
        //this.errorMessage = <any>error.reason;
      }
    );
    }
  }

  postValidate(data){
    this.showSpinner = false;
    this.fillDraftDcc(data);
    //this.successMessage = 'Votre dossier a été envoyé';
    this._notifyService.showSuccess("Votre dossier a été envoyé", "Save", 3000)

  }

  refreshCurrentDossier(data){
      if(data[0].status == "valide")
        this.isValid = true;
      else
        this.isValid = false;
      this.dcc._id = data[0]._id;
      this.diplomes = data[0].diplomes;
      this.experiences = data[0].dc.experience;
      // formatter les dates de l'experience
      // for(let exp of this.experiences){
      //   exp.to = exp.to.substr(0,10);
      //   exp.from = exp.from.substr(0,10);
      // }
      this.langues = data[0].langues;
      this.certifs = data[0].dc.certifs;
      // formatage des dates certifications
      for(let c of this.certifs)
        c.date = c.date;

      // competences
      this.skills = data[0].dc.skills;
      for(let j=0;j<data[0].dc.skills.length;j++){
        this.dskillsTags[j] = this.mapStringToTags(data[0].dc.skills[j].dskills);
      }
      this.resume = data[0].dc.resume;
      this.titre = data[0].dc.titre;
  }

  fillDraftDcc(data){
    this.showSpinner = false;
    if(data[0] != undefined){
      this.refreshCurrentDossier(data);
    }
  }

  // Map liste of tags to string
  mapTagsToString(tags){
    let str : String = '';
    for(let tag of tags){
      str+=tag.value+';';
    }
    return str;
  }

  // map string from db to tags table format
  mapStringToTags(str){
    let items  = str.split(";");
    items.pop();
    let tags : any[] =  [];
    for(let i=0;i<items.length;i++){
      let tag = new Tag();
      tag.value = items[i];
      tag.display = items[i];

      tags.push(tag);
      //tags[i].display = items[i];
    }
    return tags;
  }

  /*clearMessages(){
    this.errorMessage = '';
    this.successMessage = '';
  }*/

  currentExpChanged(actual){
    this.currentExpChecked = actual;
  }

  /*resetErrorMessage(){
    setTimeout(()=>{
      this.MsgError = '';
    }, 3000);
  }*/

 /*resetSuccesMessage(){
    setTimeout(()=>{
      this.justSaved = '';
    }, 3000);
  }  */

}



// WEBPACK FOOTER //
// ./src/app/dcc/dcc.component.ts